import { useParams } from "@tanstack/react-router";
import { ReviewTaskForm } from "@/components/reviews/ReviewTaskForm";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";
import { useReviewTask } from "@/hooks/use-review-tasks";

/** One review to fill in. See `ReviewTaskForm`. */
export function ReviewTaskPage() {
  const { reviewerId } = useParams({ from: "/dashboard/reviews/tasks/$reviewerId" });
  const { data } = useReviewTask(reviewerId);

  const subject =
    data?.relationshipKey === "self" ? "Your own review" : (data?.subjectName ?? "Review");

  useSetBreadcrumbs([
    { label: "Feedback" },
    { label: "Reviews", to: "/dashboard/reviews" },
    { label: subject },
  ]);

  return (
    <div className="space-y-6">
      <PageHeader
        title={subject}
        description={
          data
            ? `${data.relationshipName} · ${data.roleName}${data.roleLevelName ? ` · ${data.roleLevelName}` : ""} · ${data.cycleName}`
            : "Rate each area, and say what led you there."
        }
      />
      <ReviewTaskForm reviewerId={reviewerId} />
    </div>
  );
}
